import React from 'react';

import { styled } from '@mui/material/styles';
import {
    editionLevels,
    PageToolbar,
    TemplateView,
} from '@sunwisesoftware/racking-template-core';
import { Box, Button, Typography } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { custom1 } from 'common/utils/customScrolls';

const PageWrapper = styled(Box)`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: calc(100vh - 150px);
    overflow: scroll;
    ${custom1}
`;

const PageContainer = ({ isEmptyPages, onAddPage }) => {
    const { t } = useTranslation();
    if (isEmptyPages)
        return (
            <Box
                alignItems="center"
                display="flex"
                flexDirection="column"
                gap={2}
                mt={2}
                p={2}
            >
                <Typography variant="body2">
                    {t('This template has no pages')}
                </Typography>
                <Button onClick={onAddPage} variant="outlined">
                    {t('Add new page')}
                </Button>
            </Box>
        );
    return (
        <Box alignItems="center" display="flex" flexDirection="column">
            <PageToolbar />
            <PageWrapper
                pt={2}
                sx={{
                    px: { xs: 2, md: 0 },
                    alignItems: { xs: 'flex-start', md: 'center' },
                }}
            >
                <TemplateView editionLevel={editionLevels.FULL_EDITION_MODE} />
            </PageWrapper>
        </Box>
    );
};

PageContainer.propTypes = {
    isEmptyPages: PropTypes.bool,
    onAddPage: PropTypes.func,
};

export default PageContainer;
